import { render, staticRenderFns } from "./SetPersonalData.vue?vue&type=template&id=8bf775ce&scoped=true&"
import script from "./SetPersonalData.vue?vue&type=script&lang=js&"
export * from "./SetPersonalData.vue?vue&type=script&lang=js&"
import style0 from "./SetPersonalData.vue?vue&type=style&index=0&id=8bf775ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf775ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormDatePicker: require('/workspace/components/Form/FormDatePicker.vue').default,FormSelect: require('/workspace/components/Form/FormSelect.vue').default,Card: require('/workspace/components/Card.vue').default})
